import { useEffect, useRef } from 'react';
import { toast } from 'sonner';

const CHECK_INTERVAL_MS = 3 * 60 * 1000; // 3 minutes

declare const __BUILD_HASH__: string;

/**
 * Periodically fetches /version.json and compares with the build hash
 * baked into the JS bundle. If they differ, shows a toast prompting reload.
 */
export function useVersionCheck() {
  const notifiedRef = useRef(false);

  useEffect(() => {
    // Skip in dev mode (hash is "dev" or undefined)
    let currentHash: string;
    try {
      currentHash = __BUILD_HASH__;
    } catch {
      return;
    }
    if (!currentHash || currentHash === 'dev') return;

    async function check() {
      if (notifiedRef.current) return;
      try {
        const res = await fetch(`/version.json?_=${Date.now()}`, {
          cache: 'no-store',
        });
        if (!res.ok) return;
        const data = await res.json();
        if (data.buildHash && data.buildHash !== currentHash) {
          notifiedRef.current = true;
          toast.info('Hay una actualización disponible', {
            duration: Infinity,
            action: {
              label: 'Actualizar',
              onClick: () => window.location.reload(),
            },
          });
        }
      } catch {
        // Network error — silently ignore
      }
    }

    // First check after a short delay (let the app settle)
    const initialTimer = setTimeout(check, 10_000);
    const interval = setInterval(check, CHECK_INTERVAL_MS);

    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
}
